/*
 * File: OrdersAppStore.js
 * Project: mp-mobile-app
 *
 * Created by Rob Rothe
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: MST store for orders app/page
 */
import { types } from "mobx-state-tree";
import OrderModel from "./Order";
import OrderAppViews from "../views/OrdersAppViews";
import OrderAppActions from "../actions/OrderAppActions";

const OrdersAppStore = types
  .model("OrdersAppStore", {
    orders: types.array(OrderModel)
  })
  .volatile(() => ({
    ordersFetched: false,
    isNextPageLoading: false,
    hasNextPage: false,
    pageNumber: 0,
    totalPageCount: 0,
    ordersCount: 0,
    usersOrdersCount: 0
  }))
  .actions(OrderAppActions)
  .views(OrderAppViews);

export default OrdersAppStore;
